
// @ts-nocheck
import locale__app_apps_concierge_src_lang_en_US_json from "../src/lang/en-US.json";
import locale__app_apps_concierge_src_lang_fr_FR_json from "../src/lang/fr-FR.json";
import locale__app_apps_concierge_src_lang_es_ES_json from "../src/lang/es-ES.json";
import locale__app_apps_concierge_src_lang_de_DE_json from "../src/lang/de-DE.json";
import locale__app_apps_concierge_src_lang_nl_NL_json from "../src/lang/nl-NL.json";
import locale__app_apps_concierge_src_lang_it_IT_json from "../src/lang/it-IT.json";
import locale__app_apps_concierge_src_lang_ar_SA_json from "../src/lang/ar-SA.json";


export const localeCodes =  [
  "en",
  "fr",
  "es",
  "de",
  "nl",
  "it",
  "ar"
]

export const localeLoaders = {
  "en": [{ key: "../src/lang/en-US.json", load: () => Promise.resolve(locale__app_apps_concierge_src_lang_en_US_json), cache: true }],
  "fr": [{ key: "../src/lang/fr-FR.json", load: () => Promise.resolve(locale__app_apps_concierge_src_lang_fr_FR_json), cache: true }],
  "es": [{ key: "../src/lang/es-ES.json", load: () => Promise.resolve(locale__app_apps_concierge_src_lang_es_ES_json), cache: true }],
  "de": [{ key: "../src/lang/de-DE.json", load: () => Promise.resolve(locale__app_apps_concierge_src_lang_de_DE_json), cache: true }],
  "nl": [{ key: "../src/lang/nl-NL.json", load: () => Promise.resolve(locale__app_apps_concierge_src_lang_nl_NL_json), cache: true }],
  "it": [{ key: "../src/lang/it-IT.json", load: () => Promise.resolve(locale__app_apps_concierge_src_lang_it_IT_json), cache: true }],
  "ar": [{ key: "../src/lang/ar-SA.json", load: () => Promise.resolve(locale__app_apps_concierge_src_lang_ar_SA_json), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "en",
      "language": "en-US",
      "files": [
        "/app/apps/concierge/src/lang/en-US.json"
      ]
    },
    {
      "code": "fr",
      "language": "fr-FR",
      "files": [
        "/app/apps/concierge/src/lang/fr-FR.json"
      ]
    },
    {
      "code": "es",
      "language": "es-ES",
      "files": [
        "/app/apps/concierge/src/lang/es-ES.json"
      ]
    },
    {
      "code": "de",
      "language": "de-DE",
      "files": [
        "/app/apps/concierge/src/lang/de-DE.json"
      ]
    },
    {
      "code": "nl",
      "language": "nl-NL",
      "files": [
        "/app/apps/concierge/src/lang/nl-NL.json"
      ]
    },
    {
      "code": "it",
      "language": "it-IT",
      "files": [
        "/app/apps/concierge/src/lang/it-IT.json"
      ]
    },
    {
      "code": "ar",
      "language": "ar-SA",
      "dir": "rtl",
      "files": [
        "/app/apps/concierge/src/lang/ar-SA.json"
      ]
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "no_prefix",
  "lazy": false,
  "langDir": "lang",
  "detectBrowserLanguage": {
    "alwaysRedirect": false,
    "cookieCrossOrigin": false,
    "cookieDomain": null,
    "cookieKey": "i18n_redirected",
    "cookieSecure": false,
    "fallbackLocale": "en",
    "redirectOn": "all",
    "useCookie": true
  },
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "en",
    "language": "en-US",
    "files": [
      {
        "path": "/app/apps/concierge/src/lang/en-US.json"
      }
    ]
  },
  {
    "code": "fr",
    "language": "fr-FR",
    "files": [
      {
        "path": "/app/apps/concierge/src/lang/fr-FR.json"
      }
    ]
  },
  {
    "code": "es",
    "language": "es-ES",
    "files": [
      {
        "path": "/app/apps/concierge/src/lang/es-ES.json"
      }
    ]
  },
  {
    "code": "de",
    "language": "de-DE",
    "files": [
      {
        "path": "/app/apps/concierge/src/lang/de-DE.json"
      }
    ]
  },
  {
    "code": "nl",
    "language": "nl-NL",
    "files": [
      {
        "path": "/app/apps/concierge/src/lang/nl-NL.json"
      }
    ]
  },
  {
    "code": "it",
    "language": "it-IT",
    "files": [
      {
        "path": "/app/apps/concierge/src/lang/it-IT.json"
      }
    ]
  },
  {
    "code": "ar",
    "language": "ar-SA",
    "dir": "rtl",
    "files": [
      {
        "path": "/app/apps/concierge/src/lang/ar-SA.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
